<template>
  <div v-if="isHeader">
    <span class="text-overflow text-clamp-2"
    v-tooltip="rowField.customField.label.toString().length > 24 ? rowField.customField.label : ''">{{ rowField.customField.label }}</span>
  </div>
  <div v-else-if="!isHeader">
    <mf-date
      v-if="isEditable"
      :item="orderCf"
      :is-edit="true"
      :input-props="{}"
      :placeholder='"mm/dd/yyyy"'
      :isCustomFields="true"
      @set-date="($event) => { cfValue = $event.val; updateCfValue(); }"
    />
    <div v-else>
      {{ getVal() }}
    </div>
  </div>
</template>

<script>

import { onBeforeMount, reactive, toRefs, inject, computed } from 'vue';
import MfDate from '@/components/abstract/MfDate.vue';
import moment from 'moment';
import { cloneDeep, find, isEmpty, isFunction } from 'lodash';

export default {
  name: 'Date',
  props: {
    rowField: {
      type: Object,
      default: () => ({}),
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
    isEditing: {
      type: Boolean,
    },
    emitOrderSave: {
      type: Boolean,
      default: false,
    },
    isHeader: {
      type: Boolean,
    },
  },
  components: {
    MfDate,
  },
  setup(props, { emit }) {
    const shippingEvents = inject('saveShipping');
    const state = reactive({
      cfValue: null,
      customField: {},
      orderCf: {}
    });

    onBeforeMount(() => {
      if (isEmpty(props.rowData.customFields) || !find(props.rowData.customFields, { _id: props.rowField.customField._id })) {
        if(!props.rowData.customFields) {
          props.rowData.customFields = [];
        }
        props.rowData.customFields.push(cloneDeep(props.rowField.customField));
      }
      state.customField = cloneDeep(props.rowField.customField);
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      state.orderCf = itemField;
      if (itemField && itemField.value) {
        state.cfValue = moment(itemField.value).toDate();
      }
    });
    
    const updateCfValue = async () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField) {
        itemField.value = moment(state.cfValue).toISOString();
      }
      if (props.emitOrderSave && !isEmpty(shippingEvents) && isFunction(shippingEvents.save)) {
        await shippingEvents.save(props.rowData);
      }
    };

    const isEditable = computed(() => {
      if (props.rowField.isEditable) return true;
      if (props.rowField.noEdit) return false;
      return props.isEditing;
    })

    const getVal = () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField && itemField.value) {
        state.cfValue = itemField.value;
        return moment(state.cfValue).format('MM/DD/YYYY');
      }
      state.orderCf = itemField;
      state.cfValue = null;
      return 'MM/DD/YYYY'
    }

    return {
      ...toRefs(state),
      updateCfValue,
      getVal,
      isEditable
    };
  },
};
</script>